import { useState } from "react"
import { Pressable } from "react-native"
import MCATextField  from "./MCATextField"
import RNDateTimePicker from "@react-native-community/datetimepicker";
// import { DateTimePickerEvent } from "@react-native-community/datetimepicker";
import React from 'react'


const MDatePicker = (props:any) => {
    const productData = props.data

    const [showPicker, setShowPicker] = useState(false)
    const [date, setDate] = useState(new Date())

    function openPicker() {
        setShowPicker(true)
    }

    function onPickerChanged(_:any, date:any) {
        closePicker()
        setDate(date)
        console.log("isoDate")
        console.log(isoDate)
        props.dateValueChanged(isoDate)
    }

    function renderPicker() {
        if (showPicker) {
            return <RNDateTimePicker onChange={onPickerChanged} value={date} mode="date" />
        }
        return <></>
    }

    function closePicker() {
        setShowPicker(false)
    }

    let displayDate = date.toDateString()
    let isoDate = date.toISOString()

  return (
    <>
            <Pressable key={props.keyValue} onPress={openPicker}>
                <MCATextField valueString={displayDate} data={productData} editable={false} />
            </Pressable>
            {renderPicker()}

        </>
  )
}

export default MDatePicker